export const ReactQueryKeys = {
  // Dashboard
  DASHBOARD_STATS: 'dashboard-stats',
  DASHBOARD_REVENUE: 'dashboard-revenue',
  RECENT_TRANSACTIONS: 'recent-transactions',

  // Companies
  GET_COMPANIES: 'get-companies',
  GET_COMPANY: 'get-company',

  // Users
  GET_USERS: 'get-users',
  GET_USER: 'get-user',

  // Machines
  GET_MACHINES: 'get-machines',
  GET_MACHINE: 'get-machine',

  // Products
  GET_PRODUCTS: 'get-products',
  GET_PRODUCT: 'get-product',

  // Transactions
  GET_TRANSACTIONS: 'get-transactions',
  GET_TRANSACTION: 'get-transaction',

  // Sessions
  GET_SESSIONS: 'get-sessions',

  // Wallets
  GET_WALLETS: 'get-wallets',
  GET_WALLET_TRANSACTIONS: 'get-wallet-transactions',

  // Machine Config
  GET_MACHINE_CONFIG: 'get-machine-config',

  // Analytics
  ANALYTICS_REVENUE: 'analytics-revenue',
  ANALYTICS_REVENUE_BY_COMPANY: 'analytics-revenue-by-company',
  ANALYTICS_REVENUE_BY_MACHINE: 'analytics-revenue-by-machine',
  ANALYTICS_TRANSACTION_VOLUME: 'analytics-transaction-volume',
  ANALYTICS_OVERVIEW: 'analytics-overview',

  // Emails
  GET_EMAILS: 'get-emails',
  GET_EMAIL: 'get-email',
  GET_EMAIL_STATS: 'get-email-stats',

  // Per-company payment + fiscal config
  GET_COMPANY_PAYMENT_CONFIG: 'get-company-payment-config',
  GET_COMPANY_FISCAL_CONFIG: 'get-company-fiscal-config',

  // Top-up orders + fiscal receipts
  GET_TOPUP_ORDERS: 'get-topup-orders',
  GET_TOPUP_ORDER: 'get-topup-order',

  // Feature flags / settings
  GET_FEATURE_SETTINGS: 'get-feature-settings',
} as const;
